import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "landing-body" }
const _hoisted_2 = { class: "navbar-nav flex-row" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  class: "section pt-3 pt-md-0 pb-3 pb-md-0",
  id: "top"
}
const _hoisted_8 = { class: "contents" }
const _hoisted_9 = { class: "container-fluid h-100 p-0" }
const _hoisted_10 = { class: "row m-0" }
const _hoisted_11 = { class: "col-sm-12 col-md-6 d-flex flex-column align-items-center justify-content-center h-100 col-image" }
const _hoisted_12 = { class: "img-wrapper" }
const _hoisted_13 = ["srcset", "src"]
const _hoisted_14 = { class: "underimage mt-sm-3" }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  class: "section",
  id: "storage"
}
const _hoisted_17 = {
  class: "contents",
  id: "page1"
}
const _hoisted_18 = { class: "container-fluid h-100 p-0" }
const _hoisted_19 = { class: "row m-0" }
const _hoisted_20 = { class: "col-sm-12 order-1 col-md-6 order-md-0 d-flex justify-content-center align-items-center h-100 p-5 col-image" }
const _hoisted_21 = { class: "img-wrapper" }
const _hoisted_22 = ["srcset", "src"]
const _hoisted_23 = {
  class: "section",
  id: "collaboration"
}
const _hoisted_24 = {
  class: "contents",
  id: "page2"
}
const _hoisted_25 = { class: "container-fluid h-100 p-0" }
const _hoisted_26 = { class: "row m-0" }
const _hoisted_27 = { class: "col-sm-12 col-md-6 d-flex justify-content-center align-items-center h-100 p-5 col-image" }
const _hoisted_28 = { class: "img-wrapper" }
const _hoisted_29 = ["srcset", "src"]
const _hoisted_30 = {
  class: "section",
  id: "start-now"
}
const _hoisted_31 = {
  class: "contents",
  id: "page3"
}
const _hoisted_32 = { class: "container-fluid h-100 p-0" }
const _hoisted_33 = { class: "row m-0" }
const _hoisted_34 = { class: "col-image col-sm-12 col-md-6 p-5 h-100 justify-content-center" }
const _hoisted_35 = { class: "d-flex justify-content-center m-5" }
const _hoisted_36 = ["href"]
const _hoisted_37 = { class: "mt-2 d-flex justify-content-center text-center d-link" }
const _hoisted_38 = ["href"]
const _hoisted_39 = { class: "col-sm-12 col-md-6 d-flex justify-content-center h-100 p-5 col-image" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-6 col-footer" }
const _hoisted_42 = ["href"]
const _hoisted_43 = ["href"]
const _hoisted_44 = ["href"]
const _hoisted_45 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_CookieDlg = _resolveComponent("CookieDlg")!
  const _component_ErrorWidget = _resolveComponent("ErrorWidget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", _hoisted_3, [
            _createElementVNode("a", {
              class: "nav-link",
              href: _ctx.routes.ABOUT_PRICING.url
            }, "Pricing", 8, _hoisted_4)
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("a", {
              class: "nav-link",
              href: _ctx.routes.LOGIN.url
            }, "Sign In", 8, _hoisted_6)
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.needsCookieConsent)
      ? (_openBlock(), _createBlock(_component_CookieDlg, {
          key: 0,
          ref: "cookieDlg"
        }, null, 512))
      : _createCommentVNode("", true),
    _createElementVNode("main", null, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"col-text col-sm-12 col-md-6 p-5 h-100\" data-v-4d175058><div data-v-4d175058><h1 data-v-4d175058>Project Collaboration Service</h1><div class=\"help-text\" data-v-4d175058>For your desktop GanttProject app.</div></div><div class=\"flex-row\" data-v-4d175058><i class=\"fa fa-globe-americas fa-2x fa-fw\" data-v-4d175058></i><div data-v-4d175058><a class=\"flex-fill\" href=\"#storage\" data-v-4d175058>Keep GanttProject documents always at hand. <br data-v-4d175058> Everywhere in the world. <br data-v-4d175058> Online and offline.</a><br data-v-4d175058><a class=\"btn btn-sm btn-learn-more\" href=\"#storage\" data-v-4d175058>Learn more <i class=\"fa fa-fw fa-caret-down\" data-v-4d175058></i></a></div></div><div class=\"flex-row\" data-v-4d175058><i class=\"fa fa-sync fa-2x fa-fw\" data-v-4d175058></i><div data-v-4d175058><a class=\"flex-fill\" href=\"#collaboration\" data-v-4d175058>Update projects safely and keep them synced.</a><br data-v-4d175058><a class=\"btn btn-sm btn-learn-more\" href=\"#collaboration\" data-v-4d175058>Learn more <i class=\"fa fa-fw fa-caret-down\" data-v-4d175058></i></a></div></div><div class=\"flex-row\" data-v-4d175058><i class=\"fa fa-users fa-2x fa-fw\" data-v-4d175058></i><div data-v-4d175058><a class=\"flex-fill\" href=\"#start-now\" data-v-4d175058>Build big teams and keep bills small. <br data-v-4d175058>Low cost, pay as you go pricing.</a><br data-v-4d175058><a class=\"btn btn-sm btn-learn-more\" href=\"#start-now\" data-v-4d175058>Learn more <i class=\"fa fa-fw fa-caret-down\" data-v-4d175058></i></a></div></div></div>", 1)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("img", {
                    srcset: _ctx.cdnUrl('/img/landing-img1-xs.jpg') + ' 432w,' +
                                    _ctx.cdnUrl('/img/landing-img1-sm.jpg') + ' 576w,' +
                                    _ctx.cdnUrl('/img/landing-img1-md.jpg') + ' 744w,' +
                                    _ctx.cdnUrl('/img/landing-img1-lg.jpg') + ' 900w,' +
                                    _ctx.cdnUrl('/img/landing-img1-xl.jpg') + ' 1200w,' +
                                    _ctx.cdnUrl('/img/landing-img1.jpg') + ' 2160w',
                    sizes: "(max-width: 576px)    432px,\n                                    ((max-width: 768px) and (min-height: 500px))  576px,\n                                    ((max-width: 1366px) and (min-height: 700px))      744px,\n                                    (max-width: 1920px) and (min-height: 1000px))      900px,\n                                    1200px",
                    src: _ctx.cdnUrl('/img/landing-img1-lg.jpg'),
                    class: "img-fluid",
                    alt: "Cro-Magnons Team Work"
                  }, null, 8, _hoisted_13)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("a", {
                    role: "button",
                    class: "btn btn-attention btn-lg",
                    href: _ctx.routes.SIGNUP.url
                  }, "Sign Up Now", 8, _hoisted_15)
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "scroll-down d-none d-md-flex justify-content-end" }, [
                  _createElementVNode("a", {
                    href: "#storage",
                    class: "btn btn-link"
                  }, [
                    _createElementVNode("i", { class: "fas fa-3x fa-arrow-alt-circle-down colors-primary" })
                  ])
                ], -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("img", {
                    srcset: _ctx.cdnUrl('/img/landing-img2-xs.jpg') + ' 432w,' +
                                    _ctx.cdnUrl('/img/landing-img2-sm.jpg') + ' 576w,' +
                                    _ctx.cdnUrl('/img/landing-img2-md.jpg') + ' 744w,' +
                                    _ctx.cdnUrl('/img/landing-img2-lg.jpg') + ' 900w,' +
                                    _ctx.cdnUrl('/img/landing-img2-xl.jpg') + ' 1200w,' +
                                    _ctx.cdnUrl('/img/landing-img2.jpg') + ' 2160w',
                    sizes: "(max-width: 576px)    432px,\n                                    ((max-width: 768px) and (min-height: 500px))  576px,\n                                    ((max-width: 1366px) and (min-height: 700px))      744px,\n                                    (max-width: 1920px) and (min-height: 1000px))      900px,\n                                    1200px",
                    src: _ctx.cdnUrl('/img/landing-img2-lg.jpg'),
                    class: "img-fluid",
                    alt: "Cro-Magnons Project History"
                  }, null, 8, _hoisted_22)
                ])
              ]),
              _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"col-text col-sm-12 order-xs-0 order-sm-0 col-md-6 order-md-1 p-5 h-100\" data-v-4d175058><div class=\"scroll-up d-none d-md-flex justify-content-end\" data-v-4d175058><a href=\"#top\" class=\"btn btn-link fa-3x btn-top\" data-v-4d175058><i class=\"colors-primary fas fa-arrow-alt-circle-up\" data-v-4d175058></i></a></div><h2 data-v-4d175058>Cloud Storage</h2><div class=\"flex-row\" data-v-4d175058><i class=\"fa fa-2x fa-fw fa-cloud-upload-alt\" data-v-4d175058></i><div data-v-4d175058><div data-v-4d175058>Secure and Reliable</div><div class=\"help-text\" data-v-4d175058>We store GanttProject files in a secure highly available Google Cloud Storage</div></div></div><div class=\"flex-row\" data-v-4d175058><i class=\"fa fa-2x fa-fw fa-laptop\" data-v-4d175058></i><div data-v-4d175058><div data-v-4d175058>Integrated with GanttProject Desktop</div><div class=\"help-text\" data-v-4d175058>Files stored on GanttProject Cloud are available directly from the desktop GanttProject. Nearly zero configuration required.</div></div></div><div class=\"flex-row\" data-v-4d175058><i class=\"fa fa-2x fa-fw fa-download\" data-v-4d175058></i><div data-v-4d175058><div data-v-4d175058>Available Offline</div><div class=\"help-text\" data-v-4d175058>You can make any project available offline at your local disk</div></div></div><div class=\"scroll-down d-none d-md-flex justify-content-end\" data-v-4d175058><a href=\"#collaboration\" class=\"btn btn-link fa-3x btn-down\" data-v-4d175058><i class=\"colors-primary fas fa-arrow-alt-circle-down\" data-v-4d175058></i></a></div></div>", 1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"col-text col-sm-12 col-md-6 p-5 h-100\" data-v-4d175058><h2 data-v-4d175058>Work Collaboratively</h2><div class=\"flex-row\" data-v-4d175058><i class=\"fa fa-2x fa-fw fa-shield-alt\" data-v-4d175058></i><div data-v-4d175058><div data-v-4d175058>Easy Access Management</div><div class=\"help-text\" data-v-4d175058>Create teams and add people to teams to grant them access to team project files</div></div></div><div class=\"flex-row\" data-v-4d175058><i class=\"fa fa-2x fa-fw fa-user-lock\" data-v-4d175058></i><div data-v-4d175058><div data-v-4d175058>Safe Updates</div><div class=\"help-text\" data-v-4d175058>Resolving concurrent modifications is hard. Use project locks to prevent project from being modified by anyone else.</div></div></div><div class=\"flex-row\" data-v-4d175058><i class=\"fa fa-2x fa-fw fa-bell\" data-v-4d175058></i><div data-v-4d175058><div data-v-4d175058>Get Notifications</div><div class=\"help-text\" data-v-4d175058>Stay tuned and receive notifications into desktop GanttProject when someone updates, locks or unlocks project</div></div></div><div class=\"flex-row\" data-v-4d175058><i class=\"fa fa-2x fa-fw fa-history\" data-v-4d175058></i><div data-v-4d175058><div data-v-4d175058>Project History</div><div class=\"help-text\" data-v-4d175058>We keep the history of recent project changes. Even in case of update clashes one can recover project from previous versions.</div></div></div></div>", 1)),
              _createElementVNode("div", _hoisted_27, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "scroll-up d-none d-md-flex justify-content-end" }, [
                  _createElementVNode("a", {
                    href: "#top",
                    class: "btn btn-link fa-3x btn-top"
                  }, [
                    _createElementVNode("i", { class: "colors-primary fas fa-arrow-alt-circle-up" })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("img", {
                    srcset: _ctx.cdnUrl('/img/landing-img3-xs.jpg') + ' 432w,' +
                                    _ctx.cdnUrl('/img/landing-img3-sm.jpg') + ' 576w,' +
                                    _ctx.cdnUrl('/img/landing-img3-md.jpg') + ' 744w,' +
                                    _ctx.cdnUrl('/img/landing-img3-lg.jpg') + ' 900w,' +
                                    _ctx.cdnUrl('/img/landing-img3-xl.jpg') + ' 1200w,' +
                                    _ctx.cdnUrl('/img/landing-img3.jpg') + ' 2160w',
                    sizes: "(max-width: 576px)    432px,\n                                    (max-width: 768px)      576px,\n                                    (max-width: 1366px)      744px,\n                                    (max-width: 1920px)      900px,\n                                    1200px",
                    src: _ctx.cdnUrl('/img/landing-img3-lg.jpg'),
                    class: "img-fluid",
                    alt: "Cro-Magnons happily completed their project"
                  }, null, 8, _hoisted_29)
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "scroll-down d-none d-md-flex justify-content-end" }, [
                  _createElementVNode("a", {
                    href: "#start-now",
                    class: "btn btn-link fa-3x btn-down"
                  }, [
                    _createElementVNode("i", { class: "colors-primary fas fa-arrow-alt-circle-down" })
                  ])
                ], -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _cache[7] || (_cache[7] = _createElementVNode("div", {
                  class: "d-flex justify-content-center",
                  style: {"font-size":"130%"}
                }, " GanttProject Cloud is free to start. ", -1)),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("a", {
                    role: "button",
                    class: "btn btn-attention btn-lg",
                    href: _ctx.routes.SIGNUP.url
                  }, "Sign Up Now", 8, _hoisted_36)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("a", {
                    class: "inline-link mr-2",
                    href: _ctx.routes.ABOUT_PRICING.url
                  }, "Learn more", 8, _hoisted_38),
                  _cache[6] || (_cache[6] = _createTextVNode(" about our pricing ", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "scroll-up d-none d-md-flex justify-content-end" }, [
                  _createElementVNode("a", {
                    href: "#top",
                    class: "btn btn-link fa-3x btn-top"
                  }, [
                    _createElementVNode("i", { class: "colors-primary fas fa-arrow-alt-circle-up" })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _cache[8] || (_cache[8] = _createElementVNode("h3", null, "About", -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        class: "inline-link",
                        href: _ctx.routes.ABOUT_TOS.url
                      }, "Terms of Service", 8, _hoisted_42)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        class: "inline-link",
                        href: _ctx.routes.ABOUT_PRIVACY.url
                      }, "Privacy Policy", 8, _hoisted_43)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        class: "inline-link",
                        href: _ctx.routes.ABOUT_PRICING.url
                      }, "Pricing", 8, _hoisted_44)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        class: "inline-link",
                        href: _ctx.routes.ABOUT_TEAM.url
                      }, "Our Team", 8, _hoisted_45)
                    ])
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-6 col-footer" }, [
                    _createElementVNode("h3", null, "Help Pages"),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        class: "inline-link",
                        href: "https://help.ganttproject.biz/t/read-me-first-faq-and-search/8"
                      }, "FAQ")
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        class: "inline-link",
                        href: "https://help.ganttproject.biz"
                      }, "Support Forum")
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        class: "inline-link",
                        href: "https://github.com/barsoftware/ganttproject"
                      }, "Issue Tracker")
                    ])
                  ], -1))
                ]),
                _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"row\" data-v-4d175058><div class=\"col-6 col-footer\" data-v-4d175058><h3 data-v-4d175058>Follow Us</h3><div data-v-4d175058><i class=\"fab fa-twitter-square\" data-v-4d175058></i> <a class=\"inline-link\" href=\"https://twitter.com/ganttcloud\" data-v-4d175058>Twitter</a></div><div data-v-4d175058><i class=\"fab fa-facebook-square\" data-v-4d175058></i> <a class=\"inline-link\" href=\"https://www.facebook.com/ganttcloud\" data-v-4d175058>Facebook</a></div></div><div class=\"col-6 col-footer\" data-v-4d175058><h3 data-v-4d175058>See also</h3><div data-v-4d175058><a class=\"inline-link\" href=\"https://www.ganttproject.biz\" data-v-4d175058>GanttProject Desktop</a></div></div></div>", 1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ErrorWidget, { ref: "errorWidget" }, null, 512)
  ]))
}